import React from 'react';
import { useTranslation } from 'react-i18next';
import { Field } from 'react-final-form';
import clsx from 'clsx';

import usePlatformsOptions from '../hooks/usePlatformsOptions';
import MultiselectDropdownNew from '../../../../../components/multiselect-dropdown/MultiselectDropdownNew';
import WithError from '../../../../../components/with-error/WithError';
import Icon from '../../../../../icons/Icon';
import { MEDIA_CONTENT_PLACEMENT, MEDIA_TYPES, PROJECT_VARIANTS } from '../../../../../constants';
import { ProjectProvider } from '../../../../../context/ProjectContext';

import scss from './PlatformDropdowns.module.scss';

function PlatformDropdowns(props) {
  return (
    <ProjectProvider projectType='STORY' projectVariant={PROJECT_VARIANTS.ADMIN}>
      <PlatformDropdownsInner {...props} />
    </ProjectProvider>
  );
}

export default PlatformDropdowns;

function PlatformDropdownsInner({
  className,
  mediaType = MEDIA_TYPES.IMAGE,
  placement = MEDIA_CONTENT_PLACEMENT.SINGLE,
}) {
  const platformsOptions = usePlatformsOptions({ mediaType, placement });

  return (
    <div className={clsx(scss.wrapper, className)}>
      {platformsOptions.map(({ platform, icon, label, options, iconColor }) => (
        <DropdownWrapper
          key={platform}
          name={platform}
          icon={icon}
          label={label}
          options={options}
          iconColor={iconColor}
        />
      ))}
    </div>
  );
}

const DropdownWrapper = ({ name, label, icon, options, iconColor }) => {
  const { t } = useTranslation('story');

  return (
    <Field name={name}>
      {({ meta, input }) => (
        <div className={scss.dropdownWrapper}>
          <div className={scss.dropdownLabel}>
            <Icon
              icon={icon}
              disableCommonColors
              disableCommonStyles
              className={scss.dropdownLabelIcon}
              style={{ color: iconColor, fill: iconColor }}
            />
            <span>{label}:</span>
          </div>

          <WithError isShowError={meta.touched && meta.error} errorText={t(meta.error)} isAbsolute>
            <MultiselectDropdownNew
              value={input.value ?? []}
              options={options}
              onChange={input.onChange}
              name={input.name}
              onBlur={input.onBlur}
              onFocus={input.onFocus}
              isError={meta.touched && meta.error}
              placeholder={t('select')}
              disableNewOptions
              disabled={options.length === 0}
              usePortal
              isTop
            />
          </WithError>
        </div>
      )}
    </Field>
  );
};
